const NotFound = () => {
  //class name centered is defined in index.css
  return (
    <div className="centered">
      <p>Page Not Found</p>
    </div>
  );
};

export default NotFound;
